import { useSelector } from "react-redux";
import { ImageAndDataPopUp } from "./Common/Popup/ImageAndDataPopUp/ImageAndDataPopUp";
import { underMaintanance } from "./Common/Popup/ImageAndDataPopUp/DataContent";
import logo from "./../assets/logos/logo_white.svg";
import { useEffect } from "react";

const UnderMaintanance = () => {
  const forceLogout = useSelector((state) => state?.stripeReducer?.forceLogout);
  const authReducer = useSelector((state) => state.authReducer);
  const { data: maintenanceData, isLoading } = useSelector(
    (state) => state?.maintenanceReducer?.maintenanceData,
  );

  useEffect(() => {
    if (!isLoading) {
      document.getElementById("root").style.backgroundColor = "#150f50";
    }

    return () =>
      (document.getElementById("root").style.backgroundColor = "#fbf9f6");
  }, [isLoading]);

  return isLoading ? (
    <></>
  ) : (
    <>
      <div className="desktop-under-maintanance">
        <div className="lading_page_background_img h-100">
          <div className="logo">
            <img alt="logo" src={logo} className="img-fluid" />
          </div>
          <div className="container-wrapper">
            <div className="message-container">
              <div className="context">
                <div className="message-title">Autopilot is recharging</div>
                <div className="message">
                  <div>
                    Autopilot is temporarily unavailable while we perform
                    scheduled maintenance.This update helps us improve
                    performance, security, and reliability for all users.
                  </div>
                  <div>
                    We expect to be back shortly. Thanks for your patience!
                  </div>
                  <button className="btn btn-primary btn-bond w-100 mt-10 px-3 d-none">
                    Get Notified
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {authReducer.isLogin === true &&
        window.location.href.includes("bank") && (
          <ImageAndDataPopUp show={forceLogout} modalData={underMaintanance} />
        )}
    </>
  );
};

export default UnderMaintanance;
